import styled from '@emotion/styled';
import { breakpoints } from '$theme';

export const StyledM110TallySplit = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[2],
    [breakpoints.md]: {
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        gap: theme.space[5],
        width: '100%',
    },
}));
